import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { bulan } from "../../util/constant";
import moment from "moment";
import LogoTim from "../../Assets/logo-tim-sj.jpeg";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";

const PdfSuratJalan = (data) => {
  const listData = data && data.data;

  const dataCustomer = [
    {
      customer: "CBI",
      name: "PT.CENTURY BATTERIES I",
      alamat: "JL.MITRA RAYA SELATAN 1 BLOK E / NO.17-19 KARAWANG",
      tlp: "(025)-29488812",
    },
    {
      customer: "COMPOTEC",
      name: "PT.COMPOTEC INDONESIA",
      alamat:
        "Jl. Neglasari II No. 6 (Jl. Raya Bogor KM 52), Kedung Halang, Kabupaten Bogor, Jawa Barat 16710",
      tlp: "0251-8665663",
    },
    {
      customer: "GS",
      name: "PT.GS BATTERY",
      alamat: "JL.SURYA UTAMA KAV.13-14 TELUK JAMBE KARAWANG",
      tlp: "0267-440961",
    },
    {
      customer: "TBP",
      name: "PT.TRIMITRA BATERAI P.",
      alamat: "JL.SEMPER TIMUR NO.3 CILINCING - JAKARTA",
      tlp: "(025)-4403066",
    },
    {
      customer: "YBI",
      name: "PT.YUASA BATTERY IND",
      alamat: "JL.MH THAMRIN NO.1 TANGERANG - BANTEN",
      tlp: "(025)-55757255",
    },
    {
      customer: "MELCO",
      name: "PT.MELCOINDA",
      alamat: "JL.DESA SENTUL NO.77 BOGOR - INDONESIA",
      tlp: "(021)-8762510",
    },
    {
      customer: "GSS",
      name: "PT.GS BATTERY",
      alamat:
        "KAWASAN INDUSTRI BUKIT SEMARANG BARU BLOK B3, KEL. JATIBARANG KEC. MIJEN KOTA SEMARANG JAWA TENGAH",
      tlp: "(025)-76439560",
    },
    {
      customer: "TIM2",
      name: "PT.TIM 2",
      alamat: "JL.KARANGGAN RT 01/02 NO.3 PUSPASARI - CITEUREUP BOGOR",
      tlp: "87909811",
    },
    {
      customer: "TIM1",
      name: "PT.TIM 1",
      alamat: "JL. Kapitan No. 88 RT. 02/05 Curug-Cimanggis Depok",
      tlp: "(021)-8743449",
    },
  ];

  let dataSjTemp = [];

  listData &&
    listData.forEach((element) => {
      if (element.noSj === data.noSj && element.isBatal !== true) {
        dataSjTemp.push(element);
      }
    });

  let find = dataSjTemp && dataSjTemp.find((i) => i.noSj === data.noSj);

  let dataDate = moment(data.date).utcOffset("+0700").month() + 1;

  let findBulan = bulan.find((i) => i.value === dataDate);

  let findDataCustomer =
    dataCustomer && dataCustomer.find((i) => i.customer === data.customer);

  return (
    <Document>
      <Page size="A4" style={{ padding: "8px 0px 0px 0" }}>
        <View style={{ minHeight: "37%", maxHeight: "37%" }}>
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              fontSize: "10px",
            }}
          >
            <Text style={{ width: "60%" }}>Form-WH-A1-R2</Text>
            <Text style={{ width: "40%" }}>
              Cimanggis, {moment(data.date).utcOffset("+0700").format("DD")}{" "}
              {findBulan.name.toUpperCase()}{" "}
              {moment(data.date).utcOffset("+0700").format("YYYY")}
            </Text>
          </View>

          <View style={{ flexDirection: "row", width: "100%" }}>
            <View style={{ flexDirection: "row", width: "60%" }}>
              <Image
                style={{ width: "36px", height: "42px", marginRight: "2px" }}
                src={LogoTim}
              />
              <View>
                <Text
                  style={{
                    fontSize: "13px",
                    textDecoration: "underline",
                    fontWeight: "bold",
                    marginBottom: "4px",
                    marginTop: "4px",
                  }}
                >
                  PT. TENAR INTI MANDIRI
                </Text>
                <Text
                  style={{
                    fontSize: "10px",
                    fontStyle: "italic",
                    marginBottom: "2px",
                  }}
                >
                  JL. Kapitan No. 88 RT. 02/05 Curug-Cimanggis Depok
                </Text>
                <Text style={{ fontSize: "10px", fontStyle: "italic" }}>
                  Phone : (021)8743449, 8746560 (Fax)
                </Text>
              </View>
            </View>
            <View style={{ width: "35%", fontSize: "10px" }}>
              <Text style={{ marginBottom: "2px", marginTop: "2px" }}>
                Yth.: {findDataCustomer.name}
              </Text>
              <View style={{ flexDirection: "row" }}>
                <Text>Attn: </Text>
                <Text style={{ marginBottom: "2px" }}>
                  {findDataCustomer.alamat}
                </Text>
              </View>
              <Text>Telp: {findDataCustomer.tlp}</Text>
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              width: "100%",
              fontSize: "10px",
              marginBottom: "2px",
            }}
          >
            <Text>
              SURAT JALAN NO.:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{data.noSj}
            </Text>
          </View>

          <View style={{ flexDirection: "row", width: "100%" }}>
            <View style={{ width: "60%", fontSize: "10px" }}>
              <Text>
                Kami kirim barang-barang di bawah ini dengan kendaraan:
              </Text>
            </View>
            <View
              style={{
                width: "37%",
                flexDirection: "row",
                fontSize: "10px",
                justifyContent: "space-between",
              }}
            >
              <Text>BOX</Text>
              <Text>NO.POL.&nbsp;&nbsp;{find && find.noPol}</Text>
            </View>
          </View>

          <View
            style={{
              flexDirection: "row",
              width: "100%",
              fontSize: "10px",
              marginTop: "6px",
            }}
          >
            <Text
              style={{
                width: "7%",
                borderTop: "1px dotted black",
                borderBottom: "1px dotted black",
                textAlign: "center",
              }}
            >
              No.
            </Text>
            <Text
              style={{
                width: "13%",
                borderTop: "1px dotted black",
                borderBottom: "1px dotted black",
              }}
            >
              QUANTITY
            </Text>
            <Text
              style={{
                width: "50%",
                borderTop: "1px dotted black",
                borderBottom: "1px dotted black",
                textAlign: "center",
              }}
            >
              NAMA BARANG
            </Text>
            <Text
              style={{
                width: "30%",
                borderTop: "1px dotted black",
                textAlign: "center",
                borderBottom: "1px dotted black",
              }}
            >
              KETERANGAN
            </Text>
          </View>

          {dataSjTemp &&
            dataSjTemp.map((obj, index) => {
              const isiKemasan = obj && obj.isiKemasan;
              const jumlah = obj && obj.jumlah;

              let calculateFullKemasan = jumlah / isiKemasan;

              let calculateReceh =
                jumlah - Math.floor(calculateFullKemasan) * isiKemasan;
              let detectJumlahKemasan =
                Math.floor(calculateFullKemasan) > 0
                  ? Math.floor(calculateFullKemasan)
                  : 1;

              let detectIsiPerKemasan =
                Math.floor(calculateFullKemasan) > 0
                  ? obj.isiKemasan
                  : obj.jumlah;

              let detectIsReceh =
                Math.floor(calculateFullKemasan) > 0 && calculateReceh > 0
                  ? true
                  : false;

              return (
                <View
                  style={{
                    flexDirection: "row",
                    width: "100%",
                    marginBottom: "3px",
                  }}
                >
                  <Text
                    style={{
                      width: "7%",
                      textAlign: "center",
                      fontSize: "12px",
                    }}
                  >
                    {index + 1}
                  </Text>
                  <View
                    style={{
                      width: "13%",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      fontSize: "12px",
                    }}
                  >
                    <Text>
                      {formatDot(
                        switchDotsAndCommas(numberWithCommas(obj.jumlah))
                      )}
                    </Text>
                    <Text style={{ paddingRight: "6px" }}>PCS</Text>
                  </View>
                  <View
                    style={{
                      width: "50%",
                    }}
                  >
                    {obj.isPelengkap ? (
                      ""
                    ) : (
                      <View
                        style={{
                          flexDirection: "row",
                          fontSize: "11px",
                        }}
                      >
                        <Text style={{ padding: "0 6px 0 12px" }}>
                          (&nbsp;{detectJumlahKemasan}
                          &nbsp;&nbsp;&nbsp;{obj.satuan}
                          &nbsp;&nbsp;&nbsp;X&nbsp;&nbsp;&nbsp;
                          {detectIsiPerKemasan}
                          &nbsp;&nbsp;&nbsp;PCS&nbsp;)
                        </Text>
                        {detectIsReceh ? (
                          <Text style={{ padding: "0 4px" }}>
                            +&nbsp;&nbsp;1&nbsp;{obj.satuan}
                            &nbsp;=&nbsp;
                            {formatDot(
                              switchDotsAndCommas(
                                numberWithCommas(calculateReceh)
                              )
                            )}
                            &nbsp;PCS
                          </Text>
                        ) : (
                          ""
                        )}
                      </View>
                    )}
                    <Text
                      style={{ padding: "1px 6px 0 12px", fontSize: "11px" }}
                    >
                      {obj.customer === "YBI" ? obj.kodeBarang : ""}{" "}
                      {obj.itemPo}{" "}
                      {obj.isPelengkap && obj.customer === "TBP"
                        ? `- TERPASANG`
                        : ""}
                    </Text>
                  </View>

                  <View
                    style={{
                      width: "30%",
                      fontSize: "11px",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginRight: "12px",
                      }}
                    >
                      <Text>NO.PO.{obj && obj.noPo}</Text>
                      <Text>{obj && obj.kodeLine}</Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      {obj.noLine ? (
                        <Text>NO.LINE:{obj && obj.noLine}</Text>
                      ) : (
                        <></>
                      )}
                      {obj.noSkk ? <Text>SKK:{obj && obj.noSkk}</Text> : <></>}
                    </View>
                  </View>
                </View>
              );
            })}
        </View>

        <View
          style={{
            flexDirection: "row",
            width: "100%",
            fontSize: "10px",
            borderTop: "1px dotted black",
            paddingTop: "6px",
          }}
        >
          <View style={{ width: "32%", alignItems: "center" }}>
            <Text style={{ marginBottom: "36px" }}>Diterima</Text>
            <Text>
              (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
            </Text>
          </View>
          <View style={{ width: "32%", alignItems: "center" }}>
            <Text
              style={{
                fontStyle: "italic",
                marginBottom: "36px",
              }}
            >
              Supir
            </Text>
            <Text>
              (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
            </Text>
          </View>
          <View style={{ width: "32%", alignItems: "center" }}>
            <Text style={{ marginBottom: "36px" }}>Hormat Kami</Text>
            <Text>
              (&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PdfSuratJalan;
